import Swiper, { Navigation, Pagination, EffectFade } from "swiper";
Swiper.use([Navigation, Pagination, EffectFade]);

export default class HeroSwiper {
  init() {
    const heroSliderID = document.getElementById("hero-slider");

    if (!heroSliderID) return;

    const nextArrow = heroSliderID.querySelector(".hero-btn-next");
    const prevArrow = heroSliderID.querySelector(".hero-btn-prev");
    const pagination = heroSliderID.querySelector(".hero-pagination");

    this.swiper = new Swiper(heroSliderID, {
      slidesPerView: 1,
      effect: "fade",
      loop: true,
      // autoplay: {
      //   delay: 4000,
      //   disableOnInteraction: false,
      // },
      // speed: 1000,
      speed: 500,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
    });
  }
}
